var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone1SvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#e363a8",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "microphone1"), /*#__PURE__*/React.createElement("path", {
    d: "M16.401 25.911v2.995c2.995 0.162 5.312 1.154 5.312 2.078 0 0.023-12.282 0.023-12.282 0 0-0.891 2.144-1.851 4.979-2.064v-3.021c-3.619-0.519-6.41-3.6-6.41-7.363v-1.493h0.996v1.493c0 3.574 2.897 6.472 6.471 6.473h0.004c3.574-0.001 6.533-2.898 6.533-6.473v-1.493h0.996v1.493c0 3.806-2.919 6.911-6.599 7.375zM15.468 23.951c-3.024 0-5.478-2.453-5.478-5.478v-1.431h11.018v1.431c0 3.025-2.516 5.478-5.54 5.478zM9.99 7.475c0-3.025 2.453-5.477 5.478-5.477s5.54 2.452 5.54 5.477v8.572h-11.018v-8.572z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone1SvgrepoCom);
export default __webpack_public_path__ + "static/media/microphone1-svgrepo-com.2489c9c32e8216293606a054d546f6c8.svg";
export { ForwardRef as ReactComponent };